import {
  BUYER_TYPE_DESCRIPTIONS,
  SELLER_TYPE_DESCRIPTIONS
} from '@/src/components/manage-investor/buyerSellerTaxonomy'

export const FILTER_LIST_OPTIONS: FilterOptionTypes[] = [
  {
    name: 'List type',
    value: 1,
    id: 1
  },
  {
    name: 'List status',
    value: 2,
    id: 2
  }
]

export const DISTRIBUTION_LIST_TYPE_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Dynamic', id: 'dynamic', value: 'Dynamic' },
  { name: 'Custom', id: 'custom', value: 'Custom' }
]

export const DISTRIBUTION_LIST_STATUS_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Active', id: 'active', value: 'Active' },
  { name: 'Archived', id: 'archived', value: 'Archived' }
]

export const CONTENT_PAGE_CATEGORY_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Announcements', id: 'announcement', value: 'Announcements' },
  { name: 'News & Insights', id: 'update', value: 'News & Insights' },
  { name: 'Research', id: 'research', value: 'Research' }
]

// Descriptions come from the shared Manage Investors maps so the
// classification definitions stay in lockstep across both surfaces
// (the BE shares the classifier; these are just the display strings).
export const DASHBOARD_TYPE_OPTIONS: FilterCategoryTypes[] = [
  { type: 'group', name: 'BUYERS' },
  { name: 'New', id: 'New', value: 'New', description: BUYER_TYPE_DESCRIPTIONS.new },
  {
    name: 'Returning',
    id: 'Returning',
    value: 'Returning',
    description: BUYER_TYPE_DESCRIPTIONS.returning
  },
  {
    name: 'Existing',
    id: 'Existing',
    value: 'Existing',
    description: BUYER_TYPE_DESCRIPTIONS.existing
  },
  { type: 'group', name: 'SELLERS' },
  {
    name: 'Exited',
    id: 'Exited',
    value: 'Exited',
    description: SELLER_TYPE_DESCRIPTIONS.exited
  },
  {
    name: 'Partial',
    id: 'Partial',
    value: 'Partial',
    description: SELLER_TYPE_DESCRIPTIONS.partial
  }
]

export const DASHBOARD_CATEGORY_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Strategic', id: 'Strategic', value: 'Strategic' },
  { name: 'Significant', id: 'Significant', value: 'Significant' },
  { name: 'Minor', id: 'Minor', value: 'Minor' },
  { name: 'Micro', id: 'Micro', value: 'Micro' }
]

export const QUESTION_PAGE_CATEGORY_OPTIONS: FilterCategoryTypes[] = [
  // {
  //   name: "All questions",
  //   value: "all",
  //   id: "all",
  // },
  {
    name: 'Answered',
    value: 'answered',
    id: 'answered'
  },
  {
    name: 'Unanswered',
    value: 'unanswered',
    id: 'unanswered'
  },
  {
    name: 'Ignored',
    value: 'ignored',
    id: 'ignored'
  },
  {
    name: 'Draft',
    value: 'draft',
    id: 'draft'
  }
]

export const EMAIL_PAGE_CATEGORY_OPTIONS: FilterCategoryTypes[] = [
  {
    name: 'Draft',
    value: 'draft',
    id: 'draft'
  },
  {
    name: 'Outbox',
    value: 'sent',
    id: 'sent'
  }
]

export const SOCIALPOST_PAGE_CATEGORY_OPTIONS: FilterCategoryTypes[] = [
  {
    name: 'Linkedin',
    value: 'linkedin',
    id: 'linkedin'
  },
  {
    name: 'Twitter',
    value: 'twitter',
    id: 'twitter'
  }
]

export const SOCIALPOST_CREATED_VIA_OPTIONS: FilterCategoryTypes[] = [
  {
    name: 'Relait',
    value: 'relait',
    id: 'relait'
  },
  {
    name: 'External',
    value: 'external',
    id: 'external'
  }
]

export const CONTENT_PAGE_STATUS_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Draft', id: 'draft', value: 'Draft' },
  { name: 'Published', id: 'published', value: 'Published' },
  { name: 'Scheduled', id: 'scheduled', value: 'Scheduled' }
]

export const CONTENT_PAGE_LABEL_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Company Reports', id: 'Annual Report', value: 'Annual Report' },
  { name: 'Price Sensitive', id: 'Price Sensitive', value: 'Price Sensitive' },
  { name: 'Presentation', id: 'Presentation', value: 'Presentation' }
]

export const MANAGE_INVESTOR_INVESTOR_TYPE: FilterCategoryTypes[] = [
  { name: 'Shareholders', id: 'shareholders', value: 'Shareholders' },
  {
    name: 'Ex-Shareholders',
    id: 'ex-shareholders',
    value: 'Ex-Shareholders'
  },
  {
    name: 'Non-Shareholders',
    id: 'non-shareholders',
    value: 'Non-Shareholders'
  },
  { name: 'Members', id: 'members', value: 'Members' },
  { name: 'Contact', id: 'contacts', value: 'Contact' },
  { name: 'Widget Contact', id: 'widget-contact', value: 'Widget Contact' }
]

export const MANAGE_INVESTOR_STATUS_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Active', id: 'active', value: 'Active' },
  { name: 'Suppressed', id: 'suppressed', value: 'Suppressed' },
  { name: 'Unsubscribed', id: 'unsubscribed', value: 'Unsubscribed' }
]

export const MANAGE_INVESTOR_CATEGORY_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Strategic', id: 'Strategic', value: 'Strategic' },
  { name: 'Significant', id: 'Significant', value: 'Significant' },
  { name: 'Minor', id: 'Minor', value: 'Minor' },
  { name: 'Micro', id: 'Micro', value: 'Micro' },
  { name: 'Uncategorised', id: 'Uncategorised', value: 'Uncategorised' }
]

export const MANAGE_INVESTOR_NOMINEE_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Nominee accounts', id: 'nominees', value: 'nominees' },
  { name: 'Other accounts', id: 'other', value: 'other' }
]

export const INVESTOR_ENQ_FILTER_LIST_OPTIONS: FilterContentOptionTypes[] = [
  {
    name: 'Resolution',
    value: 1,
    id: 1,
    options: [
      { name: 'Resolved', id: 'resolved', value: 'Resolved' },
      { name: 'Unresolved', id: 'unresolved', value: 'Unresolved' }
    ]
  },
  {
    id: 2,
    name: 'Date',
    value: 2
  }
]

export const SUBS_FILTER_LIST_OPTIONS: FilterOptionTypes[] = [
  {
    name: 'Company',
    value: 1,
    id: 1
  },
  {
    name: 'Plan',
    value: 2,
    id: 2
  },
  {
    name: 'Status',
    value: 3,
    id: 3
  },
  {
    name: 'Date created',
    value: 4,
    id: 4
  }
]

export const NEWS_INSIGHTS_TYPE_OPTIONS: FilterCategoryTypes[] = [
  { name: 'Article', id: 'web', value: 'web' },
  { name: 'Video', id: 'video', value: 'video' },
  { name: 'PDF', id: 'pdf', value: 'pdf' },
  { name: 'Content', id: 'content', value: 'content' }
]

export const WELCOME_SECTION_MEDIA_TYPE: FilterOptionStringTypes[] = [
  { name: 'None', id: 'none', value: 'none' },
  { name: 'Image', id: 'image', value: 'image' },
  { name: 'Unith (Digital Human)', id: 'unith', value: 'unith' },
  { name: 'Video', id: 'video', value: 'video' },
  { name: 'Youtube', id: 'youtube', value: 'youtube' }
]

export interface FilterCategoryTypes {
  name: string
  id?: string | number
  value?: string | number
  type?: string
  // Hover tooltip shown on the option in SelectFilter menus.
  description?: string
}
export interface FilterContentOptionTypes {
  name: string
  value: number
  id: number
  options?: {
    // Make this optional since not all filter options have sub-options
    name: string
    id: string | number
    value: string | number
  }[]
}

export interface SelectedFIlterTypes {
  id: number
  options: FilterOptionTypes[]
  defaultValue: number | string
}

export interface FilterTypes {
  name: string | string[]
  component: React.ReactNode
  id: number
}

export interface FilterOptionTypes {
  name: string
  value: number
  id: number
}

export interface FilterOptionStringTypes {
  name: string
  value: string
  id: string
}

export interface DateRange {
  from_date: string // Assume date strings are in ISO format for simplicity
  to_date: string
}

export interface FilterValue {
  name: string
  value: string | string[] | any | { min?: number; max?: number } | { from?: any; to?: any }
}

export interface FilterValues {
  [key: number]: FilterValue
}
